import { Component, OnInit, Inject, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, GeographyService, OrderService } from '@app/_services';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { FadvDatePickerComponent, FadvIconLibraryService } from '@fa-switch-sharedservices/ng-elements';
import { Candidate, CurrentAddress, Order } from '@app/_models/orders/shared';
import { CandidateComponent } from '../candidate.component';
import { TooltipMessageService } from '@app/_services/toolservice.service';
import { BaseorderComponent } from '@app/order/baseorder/baseorder.component';
import { AppComponent } from '@app/app.component';
import { levelOfEducation } from '@app/_models';

@Component({
  selector: 'app-candidateentry',
  templateUrl: './candidateentry.component.html',
  styleUrls: ['./candidateentry.component.less']
})
export class CandidateentryComponent extends BaseorderComponent implements OnInit {
  token: string;
  caseID: number;
  loading = false;
  submitted = false;
  disableFirstName: boolean;
  disableLastName: boolean;
  displayedFirstName: string;
  requireMiddleName = false;
  clientName: string;
  error = false;
  errorMessage: string;
  addressTooltip: string;
  legalNameTooltip: string;
  hideDatePicker: Boolean;
  employmentRequired = false;
  educationRequired = false;
  creditRequired = false;
  levelsOfEducation: any;
  newOrder: Order = new Order();


  @ViewChild('fadvDatePicker') fadvDatePicker!: FadvDatePickerComponent;



  constructor(public formBuilder: UntypedFormBuilder,
    private router: Router,
    private Activatedroute: ActivatedRoute,
    public geographyService: GeographyService,
    private orderService: OrderService,
    private alertService: AlertService,
    private cdref: ChangeDetectorRef,
    private tooltipMessenger: TooltipMessageService,
    private appComponent: AppComponent
  ) {
    super(geographyService, formBuilder);
    this.token = this.Activatedroute.snapshot.paramMap.get("token");
    this.tooltipMessenger.currentDisableDobValid.subscribe(hideDatePicker => this.hideDatePicker = hideDatePicker);
  }

  ngOnInit(): void {

    this.levelsOfEducation = levelOfEducation;

    this.orderService.getCaseByToken(this.token, false).subscribe(response => {

      if (response.error) {

        if (response.message === "Order submitted.") {
          this.router.navigate(['order', 'applicant', 'complete', this.token]);
          return;
        }
        else if (response.message === "Legal forms required.") {
          this.router.navigate(['order', 'applicant', this.token]);
          return;
        }
        else {
          this.error = true;
          this.errorMessage = response.message
        }
      }
      else {
        this.newOrder.addOnProducts = response.addOnProducts;
        this.newNameTooltip();
        this.newCurrentAddressMessage();
        this.tooltipMessenger.currentAddressTooltip.subscribe(addressTooltip => this.addressTooltip = addressTooltip);
        this.tooltipMessenger.currentNameMessage.subscribe(legalNameTooltip => this.legalNameTooltip = legalNameTooltip);
        this.geographyService.getStates().subscribe(states => this.states = states);
        this.geographyService.getCountries().subscribe(countries => this.countries = countries);
        this.caseID = response.data.id;
        this.displayedFirstName = response.data.firstName;
        this.clientName = response.data.clientName;
        this.disableFirstName = response.data.firstName != undefined;
        this.disableLastName = response.data.lastName != undefined;
        this.candidate.patchValue({ firstName: response.data.firstName, lastName: response.data.lastName, email: response.data.email, confirmEmail: response.data.email });
        if (response.data.requireDL) {
          this.setRequireDL();
        }
        if (response.data.requireEducation) {
          this.handleRequireEducation();
        }
        else {
          this.removeEducationValidators();
        }
        if (response.data.requireEmployment) {
          this.handleRequireEmployment();
        }
        else {
          this.removeEmploymentValidators();
        }
        if (response.data.requireCredit) {
          this.handleRequireCredit();
        }
      }
    })
  }

  handleRequireEmployment() {
    this.employmentRequired = true;
    this.setEmploymentValidators();
  }

  handleRequireEducation() {
    this.educationRequired = true;
    this.setEducationValidators();
  }
  handleRequireCredit() {
    this.creditRequired = true;
  }
  ngAfterViewInit(): void {
    this.appComponent.application.hasFooter = false;
    this.appComponent.showHelpCenter = false;
    // window['embedded_svc'].settings.displayHelpButton = false;
  }

  setSSN(incomingSSN: string) {
    this.candidate.patchValue({ ssn: incomingSSN });
  }
  setDob(dob: Date) {
    this.candidate.patchValue({ dob: new Date(dob) });
    if (this.candidate.controls.dob.invalid) {
      this.tooltipMessenger.hideDobPicker(false);
    }
    else {
      this.tooltipMessenger.hideDobPicker(true);
    }
  }
  endDateValidator(event: any) {
    if (event) {
      var today = new Date();
      this.employment.controls.endDate.setErrors({ 'invalid': false });
      this.employment.setControl("endDate", new UntypedFormControl({ value: today, disabled: false }));
    }
    else {
      this.employment.controls.endDate.setErrors({ 'invalid': true });
      this.employment.controls.endDate.addValidators([Validators.required]);
    }
  }
  onSubmit() {

    this.loading = true;

    if (this.form.invalid) {
      this.loading = false;
      return;
    }

    this.newOrder.candidate = new Candidate();
    this.newOrder.currentAddress = new CurrentAddress();

    this.newOrder.candidate.firstName = (this.orderForm.get('candidate') as UntypedFormGroup).controls.firstName.value;
    this.newOrder.candidate.middleName = (this.orderForm.get('candidate') as UntypedFormGroup).controls.middleName.value;
    this.newOrder.candidate.lastName = (this.orderForm.get('candidate') as UntypedFormGroup).controls.lastName.value;
    this.newOrder.candidate.ssn = (this.orderForm.get('candidate') as UntypedFormGroup).controls.ssn.value;
    this.newOrder.candidate.dob = (this.orderForm.get('candidate') as UntypedFormGroup).controls.dob.value;
    this.newOrder.candidate.dlNumber = (this.orderForm.get('candidate') as UntypedFormGroup).controls.dlNumber.value;
    this.newOrder.candidate.dlState = (this.orderForm.get('candidate') as UntypedFormGroup).controls.dlState.value;
    this.newOrder.candidate.email = (this.orderForm.get('candidate') as UntypedFormGroup).controls.email.value;

    this.newOrder.currentAddress.addressLine1 = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.addressLine1.value;
    this.newOrder.currentAddress.addressLine2 = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.addressLine2.value;
    this.newOrder.currentAddress.county = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.county.value;
    this.newOrder.currentAddress.zip = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.zip.value;
    this.newOrder.currentAddress.city = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.city.value;
    this.newOrder.currentAddress.state = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.state.value;
    this.newOrder.currentAddress.country = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.country.value;

    if (this.employmentRequired == true) {
      this.addPreviousEmployer();
    }
    if (this.educationRequired == true) {
      this.addEducation();
    }
    if (this.creditRequired == true) {
      this.addCreditCheck();
    }

    this.newOrder.previousEmployers = this.previousEmployers;
    this.newOrder.education = this.institutions;

    delete this.newOrder['previousAddress'];

    this.newOrder.previousAddresses = this.previousAddresses;

    this.orderService.releaseInviteOrder(this.newOrder, this.caseID).subscribe(response => {
      if (response.error) {
        this.loading = false;
        this.alertService.error(response.message);
      }
      this.router.navigate(['order', 'applicant', 'complete', this.token]);
    });

  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  newNameTooltip() {
    this.tooltipMessenger.changeNameMessage("Please provide your legal name at it appears on your government issued identification to ensure accuracy when searching and verifying data.")
  }

  newCurrentAddressMessage() {
    this.tooltipMessenger.changeTooltip("Please provide the address for the your current place of residence.")
  }
}
